var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('az-call-to-action',{attrs:{"dark":"","active":true,"outline":false},on:{"click":_vm.acessarEdocs}},[_vm._v(" Edocs ")])}
var staticRenderFns = []

export { render, staticRenderFns }